import useSWR from "swr";
import { useSDK } from "@contentful/react-apps-toolkit";
import { FetchProps, Glossary, swrKeys } from "../lib";
import { getPlanFromCredentials } from "../utils";
import { GlossariesResponse } from "./types";
import { glossaryFromGlossaryResponse } from "./useFetchDeeplGlossary";

const DeeplGlossariesFetcher = async (credentials: string): Promise<Glossary[]> => {
    const plan = getPlanFromCredentials(credentials);

    const response = await fetch(`/api/${plan}/v3/glossaries`, {
        method: "GET",
        headers: {
            Authorization: `DeepL-Auth-Key ${credentials}`,
            Connection: "keep-alive",
        },
    });

    if (!response.ok) {
        throw new Error(`Error fetching DeepL glossaries. Status: ${response.status}`);
    }

    const data: GlossariesResponse = await response.json();

    const glossaries: Glossary[] = [];

    for (const glossaryResponse of data.glossaries) {
        glossaries.push(glossaryFromGlossaryResponse(glossaryResponse));
    }

    return glossaries;
};

export const useFetchDeeplGlossaries = (props?: FetchProps) => {
    const { skip } = props ?? {};
    const sdk = useSDK();
    const deeplCredentials = sdk.parameters.installation.deeplApiKey;

    const { data, isLoading, mutate } = useSWR(
        [swrKeys.deeplGlossaries, deeplCredentials, !!skip],
        () => (!skip ? DeeplGlossariesFetcher(deeplCredentials) : undefined),
        { revalidateOnMount: true }
    );

    return {
        data,
        isLoading,
        mutate,
    };
};
